import { FileText } from "lucide-react";
import { useLang, whatsappLink } from "../../i18n";
import { Reveal } from "../Reveal";
import { WhatsAppIcon } from "../WhatsAppButton";

export default function TechDocsPlaceholder({ project }) {
  const { t } = useLang();
  return (
    <>
        {project.technical_files?.length === 0 && (
          <Reveal className="mt-20">
            <div data-testid="tech-docs-placeholder" className="flex flex-col sm:flex-row sm:items-center justify-between gap-6 border border-dashed border-[#C8A86B]/30 bg-[#0F0F0E] p-7 sm:p-10">
              <div className="flex gap-5">
                <FileText size={26} className="shrink-0 text-[#C8A86B]" />
                <div>
                  <p className="font-serif text-xl sm:text-2xl text-[#F3EFE6]">{t.downloads_placeholder_title}</p>
                  <p className="mt-2 max-w-lg text-sm font-light text-[#A39E93] leading-relaxed">{t.downloads_placeholder_sub}</p>
                </div>
              </div>
              <a href={whatsappLink(`Buongiorno, vorrei ricevere la scheda tecnica del progetto: ${project.title_it}.`)} target="_blank" rel="noopener noreferrer" data-testid="tech-docs-request" className="inline-flex shrink-0 items-center gap-2 border border-[#C8A86B] px-6 py-3 text-xs uppercase tracking-[0.15em] text-[#C8A86B] transition-all duration-300 hover:bg-[#C8A86B] hover:text-[#080808]">
                <WhatsAppIcon size={14} /> {t.downloads_placeholder_cta}
              </a>
            </div>
          </Reveal>
        )}

    </>
  );
}
